import {
  CarOutlined,
  MessageOutlined,
  OrderedListOutlined,
  PhoneOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { createBrowserRouter } from 'react-router-dom';

import { Layout } from './components/Layout';
import { PageExecutors } from './pages/executors';
import { PageExecutor } from './pages/executors/executor';
import { PageLogin } from './pages/login';
import { PageOrders } from './pages/orders';
import { PageOrder } from './pages/orders/order';
import { PageProfile } from './pages/profile';
import { PagePushNotifications } from './pages/push-notifications';
import { PageSupportMessages } from './pages/support-messages';
import { PageUsers } from './pages/users';
import { PageUser } from './pages/users/user';

export const routes = [
  {
    path: '/',
    element: (
      <Layout>
        <PageProfile />
      </Layout>
    ),
    icon: <UserOutlined />,
    label: 'Профиль',
    inNavbar: true,
  },
  {
    path: '/users',
    element: (
      <Layout>
        <PageUsers />
      </Layout>
    ),
    icon: <UsergroupAddOutlined />,
    label: 'Пользователи',
    inNavbar: true,
  },
  {
    path: '/users/:id',
    element: (
      <Layout>
        <PageUser />
      </Layout>
    ),
  },
  {
    path: '/executors',
    element: (
      <Layout>
        <PageExecutors />
      </Layout>
    ),
    icon: <CarOutlined />,
    label: 'Исполнители',
    inNavbar: true,
  },
  {
    path: '/executors/:id',
    element: (
      <Layout>
        <PageExecutor />
      </Layout>
    ),
  },
  {
    path: '/orders',
    element: (
      <Layout>
        <PageOrders />
      </Layout>
    ),
    icon: <OrderedListOutlined />,
    label: 'Заказы',
    inNavbar: true,
  },
  {
    path: '/orders/:id',
    element: (
      <Layout>
        <PageOrder />
      </Layout>
    ),
  },
  {
    path: '/push-notifications',
    element: (
      <Layout>
        <PagePushNotifications />
      </Layout>
    ),
    icon: <MessageOutlined />,
    label: 'Push-уведомления',
    inNavbar: true,
  },
  {
    path: '/support-messages',
    element: (
      <Layout>
        <PageSupportMessages />
      </Layout>
    ),
    icon: <PhoneOutlined />,
    label: 'Обратная связь',
    inNavbar: true,
  },
  {
    path: '/login',
    element: <PageLogin />,
  },
];

export const router = createBrowserRouter(
  routes.map((item) => ({
    path: item.path,
    element: item.element,
  })),
);
